import axios, { AxiosError, type InternalAxiosRequestConfig } from "axios";

const API_BASE = import.meta.env.VITE_API_BASE ?? "/api";

export const client = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

const TOKEN_KEY = "gwiki.access_token";

export function getStoredToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setStoredToken(token: string | null) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
}

// リクエスト前: 認証ヘッダ付与
client.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// レスポンス: 401 を捕捉してログイン画面に飛ばす (loop 防止のため /auth/* は除外)
client.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    if (err.response?.status === 401) {
      const url = err.config?.url ?? "";
      if (!url.startsWith("/auth/")) {
        setStoredToken(null);
        if (window.location.pathname !== "/login") {
          window.location.href = "/login?session_expired=1";
        }
      }
    }
    return Promise.reject(err);
  }
);

/** axios エラーから人間に読めるメッセージを抽出。 */
export function extractErrorMessage(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as { detail?: unknown } | undefined;
    const detail = data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
      return detail
        .map((d) => (typeof d === "object" && d && "msg" in d ? (d as { msg: string }).msg : ""))
        .filter(Boolean)
        .join(", ");
    }
    if (err.response?.status === 0 || err.code === "ERR_NETWORK") {
      return "サーバーに接続できません。";
    }
    return err.message;
  }
  return String(err);
}
